import { Link } from 'react-router-dom';
import type { CaseItem } from '@/types/content';
import ChainTimeline from '@/components/base/ChainTimeline';
import SectionHeading from '@/components/base/SectionHeading';

interface ChainPreviewProps {
  item: CaseItem;
}

export default function ChainPreview({ item }: ChainPreviewProps) {
  return (
    <section className="w-full bg-foreground-950 text-background-100">
      <div className="w-full px-4 md:px-8 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-[0.18em] text-accent-400 uppercase">
              <span className="w-5 h-[2px] bg-accent-400 rounded-full" />
              矛盾链条
            </span>
            <h2 className="mt-3 font-heading font-black text-2xl md:text-3xl text-background-50 leading-snug">
              按时间排好，谁先谁后一目了然
            </h2>
            <p className="mt-4 text-sm md:text-base leading-7 text-background-200/80">
              矛盾链条把事件拆成按日期排列的节点，哪些是引子、哪些是回应、哪些又把矛盾推向下一层，都能顺着时间线看清楚。
            </p>
            <div className="mt-6 rounded-lg bg-background-50/5 border border-background-50/10 p-4">
              <p className="text-xs text-background-300/70 mb-2">本期示例事件</p>
              <p className="font-heading font-bold text-background-50">{item.title}</p>
              <div className="mt-3 flex items-center gap-3 text-xs text-background-300/70">
                <span className="flex items-center gap-1 whitespace-nowrap">
                  <i className="ri-git-commit-line" />
                  {item.chain.length} 个节点
                </span>
                <span className="flex items-center gap-1 whitespace-nowrap">
                  <i className="ri-time-line" />
                  {item.date}
                </span>
              </div>
            </div>
            <Link
              to="/chains"
              className="mt-6 inline-flex items-center gap-2 px-5 py-3 rounded-md bg-accent-500 text-primary-950 font-semibold hover:bg-accent-400 transition-colors whitespace-nowrap"
            >
              <i className="ri-git-commit-line" />
              浏览全部矛盾链条
            </Link>
          </div>

          <div className="lg:col-span-8 rounded-lg bg-background-50 p-5 md:p-8">
            <ChainTimeline steps={item.chain} />
          </div>
        </div>
      </div>
    </section>
  );
}